module.exports = __webpack_public_path__ + "static/media/apollo-logo-2.4b3c862d.png";